/**
 * Recursively freeze objects
 *
 * @param {Object} object - The objectthat you whant to apply Object.freeze
 * @returns {ReadonlyArray<any>} the Freezed object
 */
const Freeze = obj => obj;

export default Freeze;
